export const exampleData = () => {
  return {
    request: {
      begin: '2019-04-08',
      end: '2019-07-01',
    },
    response: {
      skupreferences: [
        {
          category: 'BLUSH',
          color: ['#ff60b0'],
          product: 'Perfect Blush',
          save: 1091,
          saveCTR: 0.0110344688,
          seriesImgUrl: '',
          shade: 'Pink',
          tryout: 98872,
          skuName: 'Perfect Blush - Pink',
        },
        {
          category: 'BLUSH',
          color: ['#ed7d80'],
          product: 'Perfect Blush',
          save: 954,
          saveCTR: 0.0117486238,
          seriesImgUrl: '',
          shade: 'Peachy',
          tryout: 81201,
          skuName: 'Perfect Blush - Peachy',
        },
        {
          category: 'BLUSH',
          color: ['#cb114f'],
          product: 'Perfect Blush',
          save: 828,
          saveCTR: 0.0105959587,
          seriesImgUrl: '',
          shade: 'Red',
          tryout: 78143,
          skuName: 'Perfect Blush - Red',
        },
        {
          category: 'BLUSH',
          color: ['#d56680'],
          product: 'Perfect Blush',
          save: 642,
          saveCTR: 0.0102802242,
          seriesImgUrl: '',
          shade: 'Rose',
          tryout: 62450,
          skuName: 'Perfect Blush - Rose',
        },
        {
          category: 'BLUSH',
          color: ['#a2694c'],
          product: 'Perfect Blush',
          save: 537,
          saveCTR: 0.0110289587,
          seriesImgUrl: '',
          shade: 'Sunset',
          tryout: 48690,
          skuName: 'Perfect Blush - Sunset',
        },
        {
          category: 'EYELINER',
          color: ['#000000'],
          product: 'Perfect Eyeliner',
          save: 656,
          saveCTR: 0.0066936726,
          seriesImgUrl: '',
          shade: '#1',
          tryout: 98003,
          skuName: 'Perfect Eyeliner - #1',
        },
        {
          category: 'EYELINER',
          color: ['#2b1845'],
          product: 'Perfect Eyeliner',
          save: 324,
          saveCTR: 0.0038916114,
          seriesImgUrl: '',
          shade: '#2',
          tryout: 83256,
          skuName: 'Perfect Eyeliner - #2',
        },
        {
          category: 'EYELINER',
          color: ['#60546a'],
          product: 'Perfect Eyeliner',
          save: 213,
          saveCTR: 0.0031368737,
          seriesImgUrl: '',
          shade: '#3',
          tryout: 67902,
          skuName: 'Perfect Eyeliner - #3',
        },
        {
          category: 'EYESHADOW',
          color: ['#a48471', '#A48672', '#74757C', '#B89692', '#422A40'],
          product: 'Perfect Eyeshadow',
          save: 582,
          saveCTR: 0.0069504986,
          seriesImgUrl: '',
          shade: '5 Pan Palette #01',
          tryout: 83735,
          skuName: 'Perfect Eyeshadow - 5 Pan Palette #01',
        },
        {
          category: 'EYESHADOW',
          color: ['#C09294', '#C1B0AC', '#D2BDCA', '#B0A5AA', '#514761'],
          product: 'Perfect Eyeshadow',
          save: 359,
          saveCTR: 0.0053174156,
          seriesImgUrl: '',
          shade: '5 Pan Palette #02',
          tryout: 67514,
          skuName: 'Perfect Eyeshadow - 5 Pan Palette #02',
        },
        {
          category: 'EYESHADOW',
          color: ['#A8A19F', '#7988A1', '#3B5668'],
          product: 'Perfect Eyeshadow',
          save: 135,
          saveCTR: 0.003450832,
          seriesImgUrl: '',
          shade: '3 Pan Palette',
          tryout: 39121,
          skuName: 'Perfect Eyeshadow - 3 Pan Palette',
        },
        {
          category: 'LIPCOLOR',
          color: ['#ff5d60'],
          product: 'Perfect Lip',
          save: 1104,
          saveCTR: 0.0117344444,
          seriesImgUrl: '',
          shade: 'Matte',
          tryout: 94082,
          skuName: 'Perfect Lip - Matte',
        },
        {
          category: 'LIPCOLOR',
          color: ['#ff1095'],
          product: 'Perfect Lip',
          save: 968,
          saveCTR: 0.0121268306,
          seriesImgUrl: '',
          shade: 'Sheer',
          tryout: 79823,
          skuName: 'Perfect Lip - Sheer',
        },
        {
          category: 'LIPCOLOR',
          color: ['#cc0b00'],
          product: 'Perfect Lip',
          save: 862,
          saveCTR: 0.0131784131,
          seriesImgUrl: '',
          shade: 'Shimmer',
          tryout: 65410,
          skuName: 'Perfect Lip - Shimmer',
        },
        {
          category: 'LIPCOLOR',
          color: ['#b84952'],
          product: 'Perfect Lip',
          save: 643,
          saveCTR: 0.0102240384,
          seriesImgUrl: '',
          shade: 'Satin',
          tryout: 62891,
          skuName: 'Perfect Lip - Satin',
        },
        {
          category: 'LIPCOLOR',
          color: ['#eb4d1e'],
          product: 'Perfect Lip',
          save: 452,
          saveCTR: 0.0081821802,
          seriesImgUrl: '',
          shade: 'Gloss',
          tryout: 55242,
          skuName: 'Perfect Lip - Gloss',
        },
      ],
    },
  };
};
